import { fechaEnChile } from './dateHelpers';

/** Los únicos campos que mira el portero. Acepta cualquier objeto que los traiga. */
export interface CamposCompromisoFoto {
  readonly foto_compromiso_hasta?: string | null;
  readonly foto_url?: string | null;
  readonly invitation_used_at?: string | null;
  readonly estado_ficha?: string | null;
}

/**
 * Decide si un miembro debe una fotografía y su plazo sigue vigente — o sea, si tiene sentido
 * ofrecerle a la JAL el recordatorio y el link para que la suba.
 *
 * Comparte las condiciones centrales con `esModoSoloFoto()` de `api/_compromisoFoto.ts`, que es
 * la autoridad para abrir el link. Son decisiones distintas: aquí se decide mostrar el recordatorio;
 * el modal además lo oculta al devolver la ficha, antes de recibir los datos actualizados.
 * `__tests__/compromisoFoto.contract.test.ts` comprueba la concordancia sin fusionar ambas políticas.
 *
 * El plazo se compara por **fecha en Chile**, no por instante: al miembro se le prometió un plazo en
 * días. Ante una fecha que no se pueda determinar, se da por vencido — cerrar de más solo esconde un
 * botón, abrir de más ofrece un link muerto.
 */
export function fotoPendienteVigente(m: CamposCompromisoFoto, ahora: number): boolean {
  const limite = m.foto_compromiso_hasta ? fechaEnChile(new Date(m.foto_compromiso_hasta)) : null;
  const hoy = fechaEnChile(new Date(ahora));

  return limite !== null
    && hoy !== null
    && hoy <= limite
    && !m.foto_url
    && !!m.invitation_used_at
    && (m.estado_ficha === 'prerregistrado' || m.estado_ficha === 'registrado');
}
